module.exports = __webpack_public_path__ + "static/media/ANGIE_RODRIGUEZ_DEV_2020.6be0b5ea.pdf";